import React from "react";
import { Heading, RadioGroup } from "@telia/teddy";
import cn from "classnames";
import "./OnboardingMobileSupportItem.less";
import { OnboardingMobileSupportService } from "../../../../../../models";

interface StartKlarMobilItemProps {
    isSelected: boolean;
    item: OnboardingMobileSupportService;
}

const OnboardingMobileSupportItem: React.FC<StartKlarMobilItemProps> = ({ item, isSelected }) => (
    <div className={cn("onboarding-mobile-support-item", { "onboarding-mobile-support-item--selected": isSelected })}>
        <RadioGroup.Item>
            <RadioGroup.Trigger value={item.code} />
            <RadioGroup.Label>
                <div className="onboarding-mobile-support-item--info">
                    <div className="onboarding-mobile-support-item--container">
                        <div className="onboarding-mobile-support-item--heading">
                            <Heading as="h3" variant="title-100">
                                {item.name}
                            </Heading>
                        </div>
                        <div className="onboarding-mobile-support-item--price">{item.price},-</div>
                    </div>
                    <div className="onboarding-mobile-support-item--container">
                        <div
                            className="onboarding-mobile-support-item--infotext"
                            dangerouslySetInnerHTML={{ __html: item.intro }}
                        />
                    </div>
                    <div className="onboarding-mobile-support-item--container">
                        <div
                            className="onboarding-mobile-support-item--infotext"
                            dangerouslySetInnerHTML={{ __html: item.description.replace(/\n/g, "<br/>") }}
                        />
                    </div>
                </div>
            </RadioGroup.Label>
        </RadioGroup.Item>
    </div>
);
export default OnboardingMobileSupportItem;
